import type { BranchConnectorPath } from './useBranchConnectorPaths';
import styles from '../InterventionGraphEditor.module.css';

interface BranchConnectorsProps {
  paths: BranchConnectorPath[];
}

// Absolutely-positioned overlay that draws the diagonal links between rows.
// Sits behind the nodes (z-index in CSS) and ignores pointer events so drag
// and drop is unaffected.
export const BranchConnectors = ({ paths }: BranchConnectorsProps) => {
  if (paths.length === 0) return null;
  return (
    <svg className={styles.branchConnectors} aria-hidden="true">
      {paths.map((path) => (
        <path key={path.id} d={path.d} className={styles.branchConnectorPath} />
      ))}
    </svg>
  );
};
